"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkUserAgent_1 = require("../utils/checkUserAgent");
const userAgent = (0, checkUserAgent_1.checkUserAgent)();
const convertMeterStr = (distance) => {
    if (!distance)
        return;
    if (distance >= 1000) {
        if (distance / 1000 < 10 &&
            (userAgent === "android" || userAgent === "ios")) {
            return `${Math.round((distance / 1000) * 10) / 10}km`;
        }
        return `${Math.floor(distance / 1000)}km`;
    }
    return `${Math.floor(distance)}m`;
};
exports.default = convertMeterStr;
